module.exports = __webpack_public_path__ + "static/media/Element_18_treatments.4c6f395e.svg";